var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEther = function SvgEther(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    fill: "#E2E8F0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ether_svg__a)",
    fill: "#718096"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M7.023 1.933V5.68l3.182 1.415-3.182-5.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M7.024 1.933 3.84 7.094 7.024 5.68V1.933Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M7.023 9.521v2.546l3.184-4.384-3.184 1.838Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M7.024 12.067V9.52L3.84 7.683l3.183 4.384Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.023 8.933 3.182-1.839L7.023 5.68v3.253Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "m3.84 7.094 3.184 1.839V5.68L3.84 7.094Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ether_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(3.792 1.75)",
    d: "M0 0h6.417v10.5H0z"
  })))));
};
export { SvgEther as ReactComponent };